module.exports = __webpack_public_path__ + "static/media/llamada.a0c1fe2d.svg";